//AuthContext.js коды авторизации пользователя
import React, { createContext, useContext, useState, useEffect } from "react";
import { useRouter } from "next/router";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Состояние загрузки
  const router = useRouter();
  const API_URL = process.env.NEXT_PUBLIC_API_URL;

  // 🔄 Восстановление пользователя при загрузке
  useEffect(() => {
    console.log("🔄 useEffect запущен — проверяем пользователя");
  
    try {
      const storedUser = localStorage.getItem("user");
      const token = localStorage.getItem("token");
  
      if (storedUser && token) {
        console.log("✅ Найден пользователь в localStorage");
        setUser(JSON.parse(storedUser));
      } else {
        console.log("⚠️ Нет токена или пользователя");
      }
    } catch (e) {
      console.warn("❌ Ошибка чтения user:", e);
      localStorage.removeItem("user");
    }
  
    setLoading(false);
  }, []);
  
  

  // 🔐 Логин пользователя
  const login = async (username, password) => {
    const res = await fetch(`${API_URL}/api/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });
  
    const data = await res.json();
  
    if (!res.ok) throw new Error(data.message || "Ошибка входа");
    if (!data.user || !data.user.id) {
      throw new Error("Ошибка: данные пользователя не получены");
    }
  
    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user));
    setUser(data.user); // ✅ вот это важно
  
    return { token: data.token, user: data.user };
  };
  

  // 🚪 Выход из аккаунта
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("user_settings");

    setUser(null);
    router.push("/");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
